const getters = {
    isPermissionCatalogCacheValid: (state, getters, rootState) =>
        Boolean(state.permissionCatalog.data) &&
        Boolean(state.permissionCatalog.expiredAt) &&
        Date.now() < state.permissionCatalog.expiredAt &&
        state.permissionCatalog.tenantId === rootState.auth.tenantId
};

export default getters;
